import React from 'react';

interface TestimonialProps {
  quote: string;
  /** Nome do autor. As iniciais geram o avatar circular. */
  author: string;
  /** Linha curta extra (cargo / cidade). */
  meta?: string;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (
    parts[0].charAt(0).toUpperCase() +
    parts[parts.length - 1].charAt(0).toUpperCase()
  );
}

/**
 * Pull quote no signup com texto serif italic e avatar circular com
 * iniciais (gradient terra, mesmo padrao do oauth-profile-card).
 *
 * Origem: templates/Login com Google/src/desktop-signup.jsx (testimonial
 * inline). Por enquanto usado com texto ficcional do template; quando
 * tiver depoimento real do losbarber/edubarber, basta trocar a prop.
 */
export function Testimonial({ quote, author, meta }: TestimonialProps) {
  return (
    <figure className="auth-testimonial">
      <blockquote className="auth-testimonial__quote">
        &ldquo;{quote}&rdquo;
      </blockquote>
      <figcaption className="auth-testimonial__author">
        <span className="auth-testimonial__avatar" aria-hidden="true">
          {initials(author)}
        </span>
        <span className="auth-testimonial__meta">
          <strong className="auth-testimonial__name">{author}</strong>
          {meta ? ` · ${meta}` : ''}
        </span>
      </figcaption>
    </figure>
  );
}
